export const searchTypeLabels = {
  charging: "chargingAutoSearch",
  charging_two_charge: "chargingTwoChargeAutoSearch",
  charging_three_charge: "chargingThreeChargeAutoSearch",
  charging_fresh_anode: "chargingFreshAnodeAutoSearch",
  charging_wet: "chargingWetAutoSearch",
  charging_two_charge_wet: "chargingTwoChargeWetAutoSearch",
  medium_term_charging: "mediumTermChargingAutoSearch",
  purchasing: "purchasingAutoSearch",
  purchasing_unrestricted: "purchasingUnrestrictedAutoSearch",
  simulator: "simulatorAutoSearch",
} as const;
